import React from "react";
import { useAura } from "@/context/AuraContext";
import { Zap } from "lucide-react";

// Global +Aura burst overlay. Floats satisfying spectrum bursts on positive events.
export function AuraBurstLayer() {
  const { bursts } = useAura();
  return (
    <div className="pointer-events-none fixed inset-x-0 top-24 z-[120] flex flex-col items-center gap-2">
      {bursts.map((b) => (
        <div
          key={b.id}
          data-testid="aura-burst"
          className="relative"
          style={{ animation: "am-burst-float 1.6s cubic-bezier(0.2,0.7,0.2,1) forwards" }}
        >
          <div className="absolute inset-0 -z-10 aura-radial blur-2xl opacity-70 scale-150" />
          <div className="flex items-center gap-2 rounded-full border border-white/15 glass-strong px-4 py-2 shadow-2xl">
            <span className="grid h-6 w-6 place-items-center rounded-full aura-gradient">
              <Zap className="h-3.5 w-3.5 text-black" strokeWidth={2.5} />
            </span>
            <span className="font-mark text-lg font-extrabold aura-text">+{b.amount} Aura</span>
          </div>
        </div>
      ))}
    </div>
  );
}
